import { gatewayClient, createService } from './connectors/httpClient';
import { createQuery as createQueryGeneric } from 'packages/helpers/queryString';
import type { BrandColorPalette } from 'packages/store/brandColors/types';

const createQuery = (params) => `?${createQueryGeneric(params)}`;

const httpClient = gatewayClient('/color-palettes');

const colorPalettesService = createService(httpClient, (client) => ({
    getPalettes() {
        return client
            .get<{
                items: BrandColorPalette[];
                totalItems: number;
            }>(`${createQuery({ sort: ['date_created', 'DESC'] })}&includeDeleted=true`)
            .then(({ status, json: { items: palettes, totalItems } }) => {
                return { status, json: { palettes, totalItems } };
            });
    },

    getPalette(id) {
        return client.get(`/${id}`).then(({ status, json }) => ({ status, palette: json }));
    },

    addPalette(name) {
        return client.post<{ id: number }>('', { name });
    },

    renamePalette(id, name) {
        return client.put<{ id: number }>(`/${id}`, { name });
    },

    deletePalette(ids) {
        return client.delete('', { ids });
    },
}));

export default colorPalettesService;
